module.exports = __webpack_public_path__ + "img/newArea.6b166170.png";